import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { useExpressCheckoutLabels } from '../../hooks/common/use-express-checkout-labels.js';

const useGetExpressLabels = (paymentType)=>{
    const { getTitle  } = useExpressCheckoutLabels();
    const { getLabel , getFormattedLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            generic: {
                title: getLabel('checkout.generic.title')
            },
            yourDetails: getLabel('checkout.yourDetails'),
            billingAddress: getLabel('checkout.billingAddress'),
            completed: {
                shipmentDetailsDelivery: getLabel('checkout.completed.shipmentDetails.delivery')
            },
            contactTitle: getLabel('checkout.contact.title'),
            shipmentAddress: getLabel('checkout.shipment.address'),
            paymentMethod: getTitle(paymentType),
            address: getLabel('checkout.summary.shipment.address'),
            differentDeliveryAddress: getLabel('checkout.shipment.differentDeliveryAddress'),
            nearestPickupMessage: getLabel('checkout.summary.shipment.nearestPickup.message'),
            implicitTerms: getFormattedLabel('checkout.disclaimer.conditions', {
                parseLink: true,
                openLinksInNewTab: true
            })
        })
    , [
        getLabel,
        getFormattedLabel,
        getTitle,
        paymentType
    ]);
    const deliveryLabels = React.useMemo(()=>({
            summary: {
                delivery: getLabel('checkout.summary.shipment.delivery'),
                deliveryExpress: getLabel('checkout.summary.shipment.deliveryExpress'),
                pickupStore: getLabel('checkout.summary.shipment.pickup'),
                pickupPoint: getLabel('checkout.summary.shipment.pickupPoint'),
                nearestPickup: getLabel('checkout.summary.shipment.nearestPickup'),
                address: getLabel('checkout.summary.shipment.address'),
                deliveryPremium: getLabel('checkout.summary.shipment.deliveryPremium')
            }
        })
    , [
        getLabel
    ]);
    return {
        labels,
        summaryLabels: deliveryLabels
    };
};

export { useGetExpressLabels };
//# sourceMappingURL=use-get-express-labels.js.map
